import { ArrowUpRight, Scale, Home as HomeIcon, BadgeIndianRupee } from "lucide-react";
import { t } from "@/lib/i18n";
import { useSite } from "@/context/SiteContext";

const CHIPS = [
  { icon: HomeIcon, text: "Doorstep pickup", cls: "top-6 -left-4 sm:-left-10", delay: "0s" },
  { icon: Scale, text: "Weighed in front of you", cls: "bottom-24 -right-3 sm:-right-8", delay: "1.2s" },
  { icon: BadgeIndianRupee, text: "Transparent rates", cls: "bottom-4 left-6", delay: "2.4s" },
];

export default function Hero() {
  const { content: c } = useSite();
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 jali-bg opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-16 pb-20 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-6">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[var(--marigold-soft)] text-[#7A4B07] text-xs font-bold tracking-wide uppercase fade-up" data-testid="hero-eyebrow">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--marigold)]" /> {c.hero_eyebrow}
          </span>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.02] fade-up" style={{ animationDelay: "80ms" }} data-testid="hero-title">
            {c.hero_title}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[var(--ink-soft)] leading-relaxed max-w-xl fade-up" style={{ animationDelay: "160ms" }} data-testid="hero-subtitle">
            {c.hero_subtitle}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3 fade-up" style={{ animationDelay: "240ms" }}>
            <a href={c.consumer_app_url} className="btn-leaf text-base" data-testid="hero-book-pickup-btn">
              {c.consumer_cta_label} <ArrowUpRight size={18} />
            </a>
            <a href={c.partner_app_url} className="btn-ghost text-base" data-testid="hero-partner-btn">
              {c.partner_cta_label} <ArrowUpRight size={18} />
            </a>
          </div>
          <p className="mt-5 text-xs text-[var(--ink-soft)] fade-up" style={{ animationDelay: "320ms" }}>
            {t("Free to book · Sign up with your phone number on app.kindsaver.com")}
          </p>
        </div>

        <div className="lg:col-span-6 relative fade-up" style={{ animationDelay: "200ms" }}>
          <div className="relative mx-auto max-w-[540px]">
            <div className="absolute -inset-4 arch bg-[var(--stone)] rotate-[-3deg]" />
            <img src={c.image_hero} alt={t("A kabadiwala collecting newspapers at a Jaipur doorstep")}
              className="relative arch w-full aspect-[4/4.4] object-cover shadow-[0_40px_80px_-40px_rgba(20,40,26,.55)]" data-testid="hero-image" />
            {CHIPS.map(({ icon: Icon, text, cls, delay }) => (
              <div key={t(text)} className={`absolute ${cls} floaty bg-white rounded-2xl px-3.5 py-2.5 shadow-xl border border-[rgba(20,40,26,.06)] flex items-center gap-2 text-sm font-semibold`} style={{ animationDelay: delay }}>
                <span className="w-8 h-8 rounded-xl bg-[var(--leaf-soft)] text-[var(--leaf-dark)] flex items-center justify-center"><Icon size={16} /></span>
                {t(text)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
